import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Doughnut, Bar } from "react-chartjs-2";
import { bucketTopN, stripPctLabel } from "./_shared/bucketTopN";
import CustomLegend from "./_shared/CustomLegend";
import ChartState from "./_shared/ChartState";
import { donutOptions, barOptions, sliceCursorOnHover } from "./_shared/chartTheme";

const GemstoneReportsGemTypeComp = ({ data, loading, onSliceClick, onChartTypeChange }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("doughnut");
  // Reports the current Donut/Bar (Line/Bar) view up to the page so its
  // Download PDF renders the same view - same as the Diamond cards.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { onChartTypeChange?.(chartType); }, [chartType]);
  const othersLabel = t("Others");

  const { chartData, colors } = bucketTopN(data || [], {
    labelKey: "GemType",
    valueKey: "CNT",
    chartLabel: "GemType",
    othersLabel,
  });
  const rows = chartData.slice(1);

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        data: rows.map((row) => row[1]),
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: chartType === "doughnut" ? 2 : 0,
        borderRadius: chartType === "bar" ? 4 : 0,
      },
    ],
  };

  const handleSliceClick = (_evt, elements) => {
    if (!onSliceClick || !elements?.length) return;
    const row = rows[elements[0].index];
    if (!row) return;
    const label = stripPctLabel(row[0]);
    if (label === othersLabel) return;
    onSliceClick(label);
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Gemstone Type Searches")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "doughnut" ? "edr-on" : ""}
              onClick={() => setChartType("doughnut")}
            >
              {t("Donut")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {!loading && rows.length > 0 ? (
            <>
              {chartType === "doughnut" && (
                <CustomLegend chartData={chartData} colorData={colors} />
              )}
              <div className="edr-chartwrap edr-tall">
                {chartType === "doughnut" ? (
                  <Doughnut
                    data={chartJsData}
                    options={{ ...donutOptions, onClick: handleSliceClick, onHover: sliceCursorOnHover }}
                  />
                ) : (
                  <Bar
                    data={chartJsData}
                    options={{ ...barOptions(true), onClick: handleSliceClick, onHover: sliceCursorOnHover }}
                  />
                )}
              </div>
            </>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default GemstoneReportsGemTypeComp;
